import React from 'react';
import {
  BooleanField,
  CreateButton,
  Datagrid,
  Filter,
  List,
  SearchInput,
  TextField,
  TopToolbar,
} from 'react-admin';
import Permission from '../../components/Permission';
import { PERMISSIONS } from '../../constants';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Cadastrar carregador" />
  </TopToolbar>
);

const InchargeStationFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn placeholder="Código do carregador" />
  </Filter>
);

const ListInchargeStation = (props) => (
  <Permission permission={PERMISSIONS.LIST_STATION}>
    <List
      {...props}
      title="Carregadores elétricos"
      exporter={false}
      bulkActionButtons={false}
      actions={<ListActions />}
      filters={<InchargeStationFilter />}
      empty={false}
    >
      <Datagrid rowClick="edit">
        <TextField source="code" label="Código do QR" />
        <TextField source="name" label="Identificação" emptyText="—" />
        {/* `placeName` já vem no payload da listagem — evita uma segunda requisição só
            para resolver o nome do posto. */}
        <TextField source="placeName" label="Posto" emptyText="—" />
        <BooleanField source="isActive" label="Ativo" />
      </Datagrid>
    </List>
  </Permission>
);

export default ListInchargeStation;
